//Sin funcionalidad solo despliega el footer con el mapaeo de la navegacionFooter

import { navigationFooter } from "../../propsType/Footer/menuFooter";
import { colors } from "../../propsType/Colors";
import visa from '../../assets/visa-master.png'
const Footer = () => {
  return (
    <footer className={`bg-[${colors.darkBlue}]`}>
      <div className="max-w-7xl mx-auto py-12 px-4 overflow-hidden sm:px-6 lg:px-8">
        <nav
          className="-mx-5 -my-2 flex flex-wrap justify-center"
          aria-label="Footer"
        >
          {navigationFooter.main.map((item) => (
            <div key={item.name} className="px-1 py-2">
              <a
                target="_blank"
                href={item.href}
                className="text-base text-white hover:text-gray-500"
              >
                {item.name}
              </a>
            </div>
          ))}
        </nav>
        <div className='flex justify-center mt-3 items-center gap-5'>
          <img className='w-[120px] ' src={visa} alt="" />
          <a href="javascript:window.open('https://seal.godaddy.com/verifySeal?sealID=HqacJjEI9siP0Rsk8DJwAJ4kAtZ0dohRVpDgn4FgjYosHoTzAeqM8NRbXWjM','mypopuptitle','location=50,width=600,height=500')">
          <img 
            className="h-8 w-auto sm:h-10" 
            src={"https://seal.godaddy.com/images/3/es/siteseal_gd_3_h_l_m.gif"} 
            alt="SSL site seal - click to verify" />
          </a>
        </div>
        <div className="mt-8 flex justify-center space-x-6">
          {navigationFooter.social.map((item) => (
            <a
              key={item.name}
              href={item.href}
              target="_blank"
              className="text-gray-400 hover:text-white"
            >
              <span className="sr-only">{item.name}</span>
              <item.icon className="h-6 w-6" aria-hidden="true" />
            </a>
          ))}
        </div>
        <p className="mt-8 text-center text-base text-gray-400">
          NetUno, Todos los derechos reservados © 2023 RIF: J-30108335-0
        </p>
      </div>
    </footer>
  );
};

export default Footer;
